function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { sdkLogger } from '../../logger';
import { SafeInterval } from '../safe-interval';
var TimedCacheItem = /*#__PURE__*/ function() {
    "use strict";
    function TimedCacheItem(item) {
        _class_call_check(this, TimedCacheItem);
        _define_property(this, "item", void 0);
        _define_property(this, "insertTime", void 0);
        this.item = item;
        this.insertTime = Date.now();
    }
    _create_class(TimedCacheItem, [
        {
            key: "ageSeconds",
            get: function get() {
                return (Date.now() - this.insertTime) / 1000;
            }
        }
    ]);
    return TimedCacheItem;
}();
export var TimedCache = /*#__PURE__*/ function() {
    "use strict";
    function TimedCache(timeoutSeconds, cleanIntervalS, destroyHandler) {
        var _this = this;
        var maxCapacity = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
        _class_call_check(this, TimedCache);
        _define_property(this, "timeoutSeconds", void 0);
        _define_property(this, "destroyHandler", void 0);
        _define_property(this, "maxCapacity", void 0);
        _define_property(this, "cache", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "safeInterval", void 0);
        this.timeoutSeconds = timeoutSeconds;
        this.destroyHandler = destroyHandler;
        this.maxCapacity = maxCapacity;
        this.cache = {};
        this.safeInterval = new SafeInterval({
            executor: function() {
                _this.clean();
            },
            timeMs: cleanIntervalS * 1000
        });
        this.safeInterval.start();
        this.logger = sdkLogger.withContext('TimedCache');
    }
    _create_class(TimedCache, [
        {
            key: "destroy",
            value: function destroy() {
                this.safeInterval.stop();
                this.cache = {};
            }
        },
        {
            key: "insert",
            value: function insert(key, item) {
                if (this.isFull) {
                    this.dropOldest();
                }
                var cacheItem = new TimedCacheItem(item);
                this.destroyCacheItem(key);
                this.cache[key] = cacheItem;
            }
        },
        {
            key: "get",
            value: function get(key, remove) {
                var cacheEntry = this.cache[key];
                var item = undefined;
                if (cacheEntry) {
                    if (cacheEntry.ageSeconds < this.timeoutSeconds) {
                        item = cacheEntry.item;
                    } else {
                        remove = true;
                    }
                } else {
                    remove = false;
                }
                if (remove === true) {
                    delete this.cache[key];
                }
                return item;
            }
        },
        {
            key: "clearCache",
            value: function clearCache() {
                var _this = this;
                Object.entries(this.cache).forEach(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    _this.logger.verbose("Cleanup -- Dropping cache key ".concat(key));
                    _this.destroyCacheItem(key);
                });
            }
        },
        {
            key: "isFull",
            get: function get() {
                return Object.keys(this.cache).length === this.maxCapacity;
            }
        },
        {
            key: "findOldest",
            value: function findOldest() {
                var _this = this;
                var keysSortedByTime = Object.keys(this.cache).sort(function(a, b) {
                    return _this.cache[b].ageSeconds - _this.cache[a].ageSeconds;
                });
                return keysSortedByTime[0];
            }
        },
        {
            key: "dropOldest",
            value: function dropOldest() {
                var oldestKey = this.findOldest();
                if (oldestKey) {
                    this.logger.verbose("Dropping oldest cache key ".concat(oldestKey));
                    this.destroyCacheItem(oldestKey);
                }
            }
        },
        {
            key: "clean",
            value: function clean() {
                var _this = this;
                Object.entries(this.cache).forEach(function(param) {
                    var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
                    if (value.ageSeconds > _this.timeoutSeconds) {
                        _this.logger.verbose("Cleanup -- Dropping expired cache key ".concat(key));
                        _this.destroyCacheItem(key);
                    }
                });
            }
        },
        {
            key: "destroyCacheItem",
            value: function destroyCacheItem(key) {
                if (!this.cache[key]) {
                    return;
                }
                this.logger.verbose("Destroying item: ".concat(key));
                this.destroyHandler(this.cache[key].item);
                delete this.cache[key];
            }
        }
    ]);
    return TimedCache;
}();

//# sourceMappingURL=timed-cache.js.map